import Base from "../Step.es6";

export default class extends Base {
    constructor(Configurator) {
        super('text', Configurator.mode.DESIGN_BOTH, Configurator);
        this.overlay    = this.Configurator.Overlay.CONTAINER_INLINE;
        this.level      = Configurator.PURCHASE_LEVEL_LOW;
        this.useVI      = false; // Do not use view interface
        this.position   = this.Configurator.Design.Tin.positions['sideText'] // Tin position
        this.values     = {
            name:           App.Variable('name'),
            description:    App.Variable('description'),
        }
    }
    get url() {
        const params = [
            'name=' + encodeURIComponent(this.values.name),
            'description=' + encodeURIComponent(this.values.description),
            'designID=' + this.Configurator.id,
        ];
        return 'text?' + params.join('&');
    }

    validate() {
        return this.ready;
    }
    commit(values) {
        this.values = values;
        this.ready  = true;
        return this;
    }
    remove() {
        this.ready = false;
        return this;
    }
    run() {
        this.ready = true;
        return this;
    }
}
